import React from "react";
import "./HowWeWork.scss";
import BreadCrumb from "../BreadCrumb/BreadCrumb";

const HowWeWork = () => {
  const items = [
    "How to add equipment?",
    "How to add drone pilot licence?",
    "How to add certification?",
    "How to complete verification?",
    "How to add social links?",
    "How to add services?",
    "How to create professional website?",
    "How to get verified on aerial borne?",
    "How leader board works?"
  ];

  return (
    <>
    <div>
      <BreadCrumb paths={[{name:'Home',path:"/dashboard"},{name:"How to use",path:""}]}/>
    </div>
    <div className="container">
      <h2 className="title">Get Matched with Clients</h2>
      <p className="subtitle">Empowering drone pilot to grow online</p>
      <div className="grid">
        {items.map((item, index) => (
          <div key={index} className="grid-item">
            {item}
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default HowWeWork;
